export const COMPANY = {
  name: "MARTYNA MOSTEK",
  displayName: "Doradca Ubezpieczeniowy MARTYNA MOSTEK",
  nip: "5732953601",
  regon: "528796131",
  email: "kontakt@ochro.pl",
  emailHref: "mailto:kontakt@ochro.pl",
  phoneDisplay: "510 509 019",
  phoneHref: "tel:+48510509019"
};

export const LEGAL_UPDATED_AT = "11 czerwca 2026 r.";
export const PRIVACY_VERSION = "ochro-privacy-2026-06-11";
export const COOKIE_STORAGE_KEY = "ochro-cookie-consent";
export const CONTACT_CONSENT_TEXT =
  "Wyrażam zgodę na kontakt telefoniczny w celu obsługi mojego zgłoszenia dotyczącego ubezpieczenia.";
export const PRIVACY_CONSENT_TEXT = `Potwierdzam zapoznanie się z informacją o przetwarzaniu danych przez ${COMPANY.displayName}, NIP: ${COMPANY.nip}.`;
export const MARKETING_CONSENT_TEXT =
  "Wyrażam zgodę na otrzymywanie dodatkowych informacji handlowych o podobnych produktach ubezpieczeniowych.";

export type LeadSubmitPayload = {
  name: string;
  phone: string;
  email?: string;
  city?: string;
  product: string;
  contactTime?: string;
  message?: string;
  contactConsent: boolean;
  privacyConsent: boolean;
  marketingConsent?: boolean;
  website?: string;
  selectedNeeds?: string[];
  source?: string;
  recommendation?: string;
  legalVersion?: string;
  contactConsentText?: string;
  privacyConsentText?: string;
  marketingConsentText?: string;
};

export function formatPhoneInput(value: string) {
  const digits = value.replace(/\D/g, "");
  const local = digits.startsWith("48") && digits.length > 9 ? digits.slice(2) : digits;
  return local
    .slice(0, 9)
    .replace(/(\d{3})(?=\d)/g, "$1 ")
    .trim();
}

export function hasMinimumPhoneDigits(value: string, minDigits = 9) {
  return value.replace(/\D/g, "").length >= minDigits;
}

export function formatPostalCodeInput(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 5);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}

export async function submitLead(payload: LeadSubmitPayload) {
  if (import.meta.env.DEV) {
    await new Promise((resolve) => setTimeout(resolve, 650));
    return;
  }

  const response = await fetch("/api/lead", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error("Lead endpoint returned an error");
  }
}
